import React, { useEffect, useRef, useState } from "react";
const Testimonial = (props) => {
  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Testimonials</h2>
          </div>
          <>
            <iframe
              title="myFrame"
              style={{
                border: "none",
                width: "100%",
                height: "100% !important",
              }}
              srcdoc="<script>!function(){window;var e,t=document;e=function(){var e=t.createElement('script');e.type='text/javascript',e.defer=!0,e.src='https://cdn.endorsal.io/widgets/widget.min.js';var n=t.getElementsByTagName('script')[0];n.parentNode.insertBefore(e,n),e.onload=function(){NDRSL.init('5ddc71fea8b52a6998fca494')}},'interactive'===t.readyState||'complete'===t.readyState?e():t.addEventListener('DOMContentLoaded',e())}();</script><div id='ndrsl-wol-5ddc75e8a8b52a6998fca499' class='ndrsl-widget'></div>"
            ></iframe>
          </>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
